import { useEffect, useState } from 'react';

export const useDebouncedState = <T>(value: T, delay = 500): [T, (value: T) => void] => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return [debouncedValue, setDebouncedValue];
};
